import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import Modal from '../../common/Modal';
import ModalButton from '../../common/ModalButton';
import auth from '../../../services/authService';

import './WhatsNewModal.scss';

const WhatsNewModal = ({ isOpen, onClose, release }) => {
  const { t } = useTranslation();

  if (!isOpen || !release) return null;

  const firstName = auth.getCurrentUser()?.firstName;
  const { version, changes } = release;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('dialogs.whatsNew.title')}
      footer={
        <ModalButton block onClick={onClose}>
          {t('common.gotIt')}
        </ModalButton>
      }
    >
      <div className="WhatsNewModal">
        <h2 className="greeting">
          {firstName ? t('dialogs.whatsNew.welcomeBack', { name: firstName }) : t('dialogs.whatsNew.welcomeBackNoName')}
        </h2>
        <p className="intro">
          <Trans
            i18nKey="dialogs.whatsNew.updated"
            values={{ version }}
            components={{ version: <span className="version" /> }}
          />
        </p>

        <ul className="changes">
          {changes.map((change) => (
            <li key={change}>{change}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

WhatsNewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  release: PropTypes.shape({
    version: PropTypes.string.isRequired,
    changes: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
};

export default WhatsNewModal;
